import { TodoTagEntity } from '../types/data';

export const tagData: TodoTagEntity[] = [
  {
    id: 'tag-1',
    title: '仕事',
    body: '業務関連のタスク',
    created_at: '2025-08-01T09:00:00Z',
    modified_at: '2025-08-01T09:00:00Z',
    is_deleted: false
  },
  {
    id: 'tag-2',
    title: 'プロジェクト',
    body: 'プロジェクト関連のタスク',
    created_at: '2025-08-01T09:15:00Z',
    modified_at: '2025-08-01T09:15:00Z',
    is_deleted: false
  },
  {
    id: 'tag-3',
    title: '緊急',
    body: '緊急度の高いタスク',
    created_at: '2025-08-01T10:00:00Z',
    modified_at: '2025-08-01T10:00:00Z',
    is_deleted: false
  },
  {
    id: 'tag-4',
    title: '個人',
    body: '個人的なタスク',
    created_at: '2025-08-01T10:30:00Z',
    modified_at: '2025-08-01T10:30:00Z',
    is_deleted: false
  },
  {
    id: 'tag-5',
    title: '勉強',
    body: '学習関連のタスク',
    created_at: '2025-08-01T11:00:00Z',
    modified_at: '2025-08-01T11:00:00Z',
    is_deleted: false
  }
];

// 新しいタグIDを生成する関数
export const generateTagId = (): string => {
  return `tag-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

// タグを作成する関数
export const createTag = (title: string, body?: string): TodoTagEntity => {
  const now = new Date().toISOString();
  return {
    id: generateTagId(),
    title,
    body,
    created_at: now,
    modified_at: now,
    is_deleted: false
  };
};

// アクティブなタグ（削除されていない）を取得する関数
export const getActiveTags = (): TodoTagEntity[] => {
  return tagData.filter(tag => !tag.is_deleted);
};